import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'langchain-chat-memory',
  version: '1.0.0',
  properties: [
    {
      key: 'memoryType',
      label: 'Memory Type',
      type: 'options',
      required: true,
      default: 'buffer',
      options: [
        { value: 'buffer', name: 'Buffer' },
        { value: 'bufferWindow', name: 'Buffer Window' },
        { value: 'summary', name: 'Summary' },
      ],
    },
    {
      key: 'sessionId',
      label: 'Session ID',
      type: 'string',
      required: true,
      placeholder: 'user-123',
      description: 'Unique identifier for this conversation',
    },
    {
      key: 'windowSize',
      label: 'Window Size',
      type: 'number',
      default: 5,
      displayOptions: {
        show: {
          memoryType: ['bufferWindow'],
        },
      },
      typeOptions: {
        minValue: 1,
        maxValue: 50,
      },
      description: 'Number of messages to keep in memory',
    },
  ],
};

export default schema;
